// to easily copy and paste components
import React, { useMemo } from 'react';
import {useTranslation} from 'react-i18next';
import {CurrencyValue} from "../currencyValue";
import {Month} from "../month";
import BllinkUtils from "../utils/utils";
import {constants} from "../constants/constants";

import './upComingMonths.css';

/**
 * 
 * @param {number} paymentMethodId  
 * @param {number} [tenantCommission=0] 
 * @param {{total: number, currency: string} | null} firstPayment total expected in cents
 * 
 */

export function CommissionText({firstPayment, tenantCommission = 0, paymentMethodId, isStatusPage}) {
    const { t } = useTranslation();

    const { paymentMethods } = constants.APIContract;

    // INDIAN STYLE HACK: hide 15ILS commission from the first payment of bank charge payment plan to make users calm.
    const commission = paymentMethodId === (paymentMethods.bankCharge && tenantCommission > constants.ONE_TIME_BANK_CHARGE_SETUP_FEE) ? 
    tenantCommission - constants.ONE_TIME_BANK_CHARGE_SETUP_FEE : 
    tenantCommission;

    let commissionText = '';
    if (commission > 0) {
        if (firstPayment != null) {
            if (firstPayment.total > 0) {
                //due to the fact that status page gets the total in dollars but checkout page gets total in cents
                //todo unified all amount from BE to be cents or usd.
                const originalSum = isStatusPage ? firstPayment.total : (firstPayment.total / 100);
                const commissionInDollars = BllinkUtils.Money.roundNumber(originalSum * commission / 100, 2);

                // if commission is smaller than 5 NIS -> show absolute value
                // if bigger, then show percentage
                if (commissionInDollars > 5) {
                    const commissionPercentage = BllinkUtils.Money.roundNumber(commission);
                    commissionText = t('payments.commissionTextForTenantInPercentage', { commissionPercentage });
                } else {
                    const currency = t(`currency.${firstPayment.currency}`);
                    commissionText = t('payments.commissionTextForTenantInInDollars', { commissionInDollars, currency });
                }
                commissionText += `. ${t('payments.tourist_comment')}`;
            }
        }
    }
    return commissionText;
}

export default function UpComingMonths({ paymentDetails, tenantCommission, nextMonthsPaymentsData, isStatusPage = false }) {
    const { t } = useTranslation();
    const months = nextMonthsPaymentsData.months;

    const paymentValue = useMemo(() => {
        if (months.length > 0) {
            const firstPayment = months[0];
            if (firstPayment != null) {
                return {
                    total: firstPayment.total,
                    currency: firstPayment.currency
                }
            }
        } 
        return null
    }, [])

    return (
        <div className="col-md-12">
            <div className="row">
                <div className="c_Heading_last">
                    <h3>{t('payments.future_payments_by_months')}</h3>
                    <h3 className='second-header'>{t('payments.future_payments_additional_title')}</h3>
                    <h5>{t('payments.automatic_billing_note')}</h5>
                    <p>{t('payments.future_payments_sub_title')}.
                        <CommissionText 
                            tenantCommission={tenantCommission} 
                            paymentMethodId={paymentDetails?.paymentMethodId} 
                            firstPayment={paymentValue}
                            isStatusPage = {isStatusPage}
                        />
                    </p>
                </div>
                <div className="col-md-12">
                    <div className="row new-row-set2_2">
                        {months.map((payment, index) => (
                            <div key={index} className="col-md-2 boxs">
                                <label className="label_container without_checkbox">
                                    <CurrencyValue currency={payment.currency}>{payment.total * 100}</CurrencyValue>
                                    <span className="checktext"><Month>{payment.month}</Month><br/>{' '}{payment.year}</span>
                                </label>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
